import ShapeSet from 'pages/ShapeSet';
import autoformPlaceholder from '../images/autoform-unselected.png';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';

export const shapeSetRoutes = {
    path: '/shape-set',
    element: <ShapeSet />,
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />,
        },
        {
            path: ':itemId',
            element: <AutoformContainer />,
        },
    ],
};
